import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Form, Input, Button, Row, Col } from "antd";
import { useDispatch } from "react-redux";

import "./Auth.scss";
import { doSignUp } from "../../../modules/auth/stores/thunk";

const SignUpForm = () => {
  const [form] = Form.useForm();
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  const handleSubmit = (params) => {
    dispatch(doSignUp({ ...params }));
  };

  return (
    <div className={`SignUpForm`}>
      <Form
        form={form}
        scrollToFirstError
        layout="vertical"
        hideRequiredMark
        colon={false}
        onFinish={handleSubmit}
      >
        <div className="Logo">
          <Link to="/">
            <img
              src={`/logo.svg`}
              alt="logo"
              style={{maxWidth: "100%"}}
            />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">
            Skapa nytt konto.
          </div>
        </div>
        <div className="FormContent">
          <Form.Item
            label="Företagsnamn"
            name="name"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input size="large" placeholder="Företagsnamn" />
          </Form.Item>
          <Form.Item
            label="E-postadress"
            name="email"
            hasFeedback
            rules={[
              { type: "email", message: "Invalid Email" },
              { required: true, message: "Required" },
            ]}
          >
            <Input
              size="large"
              placeholder="namn@företag.se"
            />
          </Form.Item>
          <Form.Item
            label="Lösenord"
            name="password"
            hasFeedback
            rules={[
              { required: true, message: "Required" },
              {
                validator(_, value) {
                  if (
                    !value ||
                    new RegExp(
                      "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(.{8,})$"
                    ).test(value)
                  ) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Invalid password"));
                },
              },
            ]}
          >
            <Input.Password
              size="large"
              placeholder="Lösenord"
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Item>
          <div className="HintPassword Invalid">
            <div className="HintTitle">Lösenord måste innehålla följande::</div>
            <Row>
              <Col span={12}>
                <div className="HintItem">
                  <img
                    src={`/icons/${
                      /.{8,}/.test(password) ? "" : "un"
                    }checked-circle.svg`}
                    alt=""
                  />{" "}
                  Minst 8 tecken
                </div>
                <div className="HintItem">
                  <img
                    src={`/icons/${
                      /[a-z]/.test(password) ? "" : "un"
                    }checked-circle.svg`}
                    alt=""
                  />{" "}
                  Minst en liten bokstav
                </div>
              </Col>
              <Col span={12}>
                <div className="HintItem">
                  <img
                    src={`/icons/${
                      /\d/.test(password) ? "" : "un"
                    }checked-circle.svg`}
                    alt=""
                  />{" "}
                  Minst en siffra
                </div>
                <div className="HintItem">
                  <img
                    src={`/icons/${
                      /[A-Z]/.test(password) ? "" : "un"
                    }checked-circle.svg`}
                    alt=""
                  />{" "}
                  Minst en stor bokstav
                </div>
              </Col>
            </Row>
          </div>
          <div className="Terms">
            Genom att registrera dig godkänner du våra <Link to="#" target="_blank" rel="noopener noreferrer">Villkor</Link> och {" "}
            <Link to="https://www.nordicrouting.se/integritetspolicy" target="_blank" rel="noopener noreferrer">Integritetspolicy</Link>
          </div>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            Registrera
          </Button>
        </div>
      </Form>
      <div className="Register">
        Har du redan ett konto? <Link to="/login">Logga in</Link>
      </div>
    </div>
  );
};

export default SignUpForm;
